import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a57ad025dd08a00142013e4_1786070684353_4a7d954f/karspostasi/src/app/contact/page.tsx");
